module.exports = __webpack_public_path__ + "media/1alB-ah-bgah.b50d7929.mp3";